import React, { useState } from "react";
import PropTypes from "prop-types";
import { NeoSideMenu, NeoSearch } from "../../../../components/Common";
import { GLOBAL_STATUS } from "../../../../constants/common";

/**
 * AcquirerSidebar
 * Componente de barra lateral para Adquirentes.
 * Migrado para o NeoSideMenu do Neo Design System.
 */
const AcquirerSidebar = ({ acquirers = [], activeId, onSelect, onCreateNew, loading }) => {
    const [searchQuery, setSearchQuery] = useState("");

    // Filtrar adquirentes com base na pesquisa local
    const filteredAcquirers = acquirers.filter((acq) => {
        const name = acq.name || "";
        return name.toLowerCase().includes(searchQuery.toLowerCase());
    });

    // Mapear adquirentes para o formato NeoSideMenu
    const sideMenuItems = filteredAcquirers.map((acq) => {
        const label = acq.name || "Adquirente";
        
        let badge = null;
        let badgeVariant = null;
        if (acq.status !== GLOBAL_STATUS.ACTIVE) {
            badge = "Inativo";
            badgeVariant = "muted";
        }

        // Descrição mostrando bandeiras habilitadas
        const flags = acq.rates ? Object.keys(acq.rates) : [];
        const description = flags.length > 0
            ? flags.slice(0, 3).map(f => f.toUpperCase()).join(", ") + (flags.length > 3 ? ` +${flags.length - 3}` : "")
            : "Nenhuma bandeira configurada";

        return {
            id: acq.id,
            label,
            description,
            icon: "mdi-credit-card-outline",
            badge,
            badgeVariant
        };
    });

    return (
        <NeoSideMenu
            title="Adquirentes"
            subtitle={`${acquirers.length} cadastradas`}
            icon="mdi-credit-card-settings-outline"
            loading={loading}
            items={sideMenuItems}
            activeId={activeId}
            onSelect={(id) => {
                const acq = acquirers.find((a) => a.id === id);
                if (acq) onSelect(acq);
            }}
            onAdd={onCreateNew}
            searchComponent={
                <NeoSearch
                    size="sm"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Buscar adquirente..."
                />
            }
        />
    );
};

AcquirerSidebar.propTypes = {
    acquirers: PropTypes.array.isRequired,
    activeId: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    onCreateNew: PropTypes.func.isRequired,
    loading: PropTypes.bool
};

export default AcquirerSidebar;
